var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _mask, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6391 43.9776C34.4251 43.9776 43.9795 34.4232 43.9795 22.6372C43.9795 10.8513 34.4251 1.29688 22.6391 1.29688C10.8532 1.29688 1.29883 10.8513 1.29883 22.6372C1.29883 34.4232 10.8532 43.9776 22.6391 43.9776Z",
    fill: "#BFB9CB",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 28.9535C29.9338 32.8735 26.7558 36.0515 22.8358 36.0515C18.9158 36.0515 15.7378 32.8735 15.7378 28.9535C15.7378 25.0335 18.9158 21.8555 22.8358 21.8555C26.7558 21.8555 29.9338 25.0335 29.9338 28.9535Z",
    fill: "#ACDE6B",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9836 33.6788C34.7586 31.4578 35.8216 28.6438 35.8216 25.5798C35.8216 18.4078 30.0076 12.5938 22.8356 12.5938C15.6636 12.5938 9.84961 18.4078 9.84961 25.5798C9.84961 28.6438 10.9136 31.4578 12.6876 33.6788H32.9836Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9058 29.9977H17.4368C14.8638 29.9977 12.7778 27.9117 12.7778 25.3387C12.7778 22.7657 14.8638 20.6797 17.4368 20.6797H27.9058C30.4788 20.6797 32.5648 22.7657 32.5648 25.3387C32.5648 27.9117 30.4788 29.9977 27.9058 29.9977Z",
    fill: "#ACDE6B",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.918 24.9593C15.356 23.7373 16.524 22.8633 17.897 22.8633C19.208 22.8633 20.332 23.6603 20.812 24.7953",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6968 24.9593C25.1348 23.7373 26.3028 22.8633 27.6758 22.8633C28.9858 22.8633 30.1108 23.6603 30.5908 24.7953",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.123 27.1211C21.236 28.0041 21.989 28.6861 22.902 28.6861C23.816 28.6861 24.568 28.0031 24.681 27.1211H21.123Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6378 27.8617C38.8868 27.8617 38.2788 27.2527 38.2788 26.5027V23.4137C38.2788 22.6627 38.8878 22.0547 39.6378 22.0547C40.3888 22.0547 40.9968 22.6637 40.9968 23.4137V26.5027C40.9968 27.2527 40.3888 27.8617 39.6378 27.8617Z",
    fill: "#694AAD",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65881 27.8617C4.90781 27.8617 4.2998 27.2527 4.2998 26.5027V23.4137C4.2998 22.6627 4.90781 22.0547 5.65881 22.0547C6.40981 22.0547 7.01782 22.6637 7.01782 23.4137V26.5027C7.01782 27.2527 6.40981 27.8617 5.65881 27.8617Z",
    fill: "#694AAD",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24436 13.3967L9.24441 13.3966C9.53061 12.9728 10.1076 12.8604 10.5331 13.1471C10.9575 13.4346 11.0691 14.011 10.7826 14.4361C9.68446 16.0612 9.10504 17.9617 9.10504 19.9308V22.1734C9.10421 22.6868 8.68865 23.1018 8.17603 23.1018C7.66318 23.1018 7.24805 22.6866 7.24805 22.1738V19.9308C7.24805 17.5881 7.93841 15.3297 9.24436 13.3967Z",
    fill: "#694AAD",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6177 14.0457L35.6175 14.0454C33.6517 11.1298 30.3815 9.38893 26.8699 9.38893H18.9319C15.4246 9.38893 12.1565 11.1266 10.1897 14.0369C10.1229 14.1357 9.98992 14.1604 9.89351 14.0951L9.89292 14.0947C9.79414 14.0279 9.76944 13.8949 9.83479 13.7985L9.83523 13.7978C11.8814 10.7692 15.2823 8.96094 18.9319 8.96094H26.8699C30.5242 8.96094 33.9258 10.7719 35.9721 13.806C36.0385 13.9048 36.0118 14.0378 35.9148 14.1031L35.9127 14.1045C35.8776 14.1284 35.8385 14.1399 35.7959 14.1399C35.7253 14.1399 35.6584 14.1062 35.6177 14.0457Z",
    fill: "#694AAD",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.027 14.4429L35.0268 14.4427C34.7404 14.0179 34.8525 13.4417 35.2777 13.1548C35.704 12.8679 36.2799 12.981 36.5654 13.4053L36.5657 13.4057C37.8678 15.3369 38.5563 17.5925 38.5563 19.9302L38.5563 22.1726C38.5563 22.1727 38.5563 22.1728 38.5563 22.1729C38.5554 22.6862 38.1399 23.1012 37.6273 23.1012C37.1144 23.1012 36.6993 22.6861 36.6993 22.1732V19.9302C36.6993 17.9641 36.1208 16.0667 35.027 14.4429Z",
    fill: "#694AAD",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34879 29.8818C6.79179 29.8818 5.52979 28.6198 5.52979 27.0638V22.5768C5.52979 21.0198 6.79179 19.7578 8.34879 19.7578C9.90579 19.7578 11.1678 21.0198 11.1678 22.5768V27.0638C11.1668 28.6198 9.90479 29.8818 8.34879 29.8818Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63556 19.7578H8.06055V29.8818H8.63556V19.7578Z",
    fill: "#ACDE6B",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.11 29.8818C35.553 29.8818 34.291 28.6198 34.291 27.0638V22.5768C34.291 21.0198 35.553 19.7578 37.109 19.7578C38.666 19.7578 39.928 21.0198 39.928 22.5768V27.0638C39.928 28.6198 38.666 29.8818 37.11 29.8818Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3968 19.7578H36.8218V29.8818H37.3968V19.7578Z",
    fill: "#ACDE6B",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8817 18.8378C24.9027 18.8378 26.7857 17.8138 27.8837 16.1168L29.1157 14.2128C27.2547 13.1828 25.1147 12.5938 22.8357 12.5938C20.4877 12.5938 18.2877 13.2198 16.3867 14.3098L18.2357 16.6118C19.3677 18.0188 21.0757 18.8378 22.8817 18.8378Z",
    fill: "#ACDE6B",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9785 31.1505C23.0945 31.1505 23.1885 31.0564 23.1885 30.9405C23.1885 30.8245 23.0945 30.7305 22.9785 30.7305C22.8626 30.7305 22.7686 30.8245 22.7686 30.9405C22.7686 31.0564 22.8626 31.1505 22.9785 31.1505Z",
    fill: "#694AAD",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1876 31.6748C23.1876 31.5588 23.0936 31.4648 22.9776 31.4648C22.8616 31.4648 22.7676 31.5588 22.7676 31.6748C22.7676 31.7908 22.8616 31.8849 22.9776 31.8849C23.0936 31.8849 23.1876 31.7908 23.1876 31.6748Z",
    fill: "#694AAD",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0957 31.4197C22.0957 31.4197 22.0957 31.4196 22.0957 31.4196C22.0618 31.3086 22.1238 31.1917 22.2347 31.1577C22.2348 31.1577 22.2348 31.1577 22.2349 31.1577C22.3456 31.1239 22.4621 31.1855 22.4965 31.2959L22.2962 31.3578L22.296 31.3578L22.1575 31.4007L22.0957 31.4197ZM22.0957 31.4197C22.1297 31.5297 22.2466 31.5927 22.3576 31.5588C22.3576 31.5588 22.3577 31.5588 22.3577 31.5588C22.4687 31.5248 22.5307 31.4079 22.4968 31.2969L22.2963 31.3583L22.2962 31.3583L22.0957 31.4197Z",
    fill: "#694AAD",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-1_6408_1178",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6688 31.5588C23.7798 31.5248 23.8418 31.4077 23.8078 31.2967C23.7738 31.1857 23.6568 31.1237 23.5458 31.1577C23.4348 31.1917 23.3728 31.3087 23.4058 31.4197C23.4408 31.5297 23.5588 31.5928 23.6688 31.5588Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6688 31.5588C23.7798 31.5248 23.8418 31.4077 23.8078 31.2967C23.7738 31.1857 23.6568 31.1237 23.5458 31.1577C23.4348 31.1917 23.3728 31.3087 23.4058 31.4197C23.4408 31.5297 23.5588 31.5928 23.6688 31.5588Z",
    fill: "#694AAD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6688 31.5588L23.376 30.6026L23.3735 30.6033L23.6688 31.5588ZM23.4058 31.4197L22.4473 31.7047L22.45 31.7139L22.4529 31.7229L23.4058 31.4197ZM23.9617 32.5149C24.6017 32.3189 24.9594 31.642 24.764 31.0039L22.8517 31.5896C22.7242 31.1735 22.9579 30.7306 23.376 30.6026L23.9617 32.5149ZM24.764 31.0039C24.5679 30.3637 23.8909 30.0062 23.2529 30.2016L23.8387 32.1139C23.4227 32.2413 22.9798 32.0078 22.8517 31.5896L24.764 31.0039ZM23.2529 30.2016C22.6122 30.3979 22.2593 31.0722 22.4473 31.7047L24.3644 31.1348C24.4864 31.5453 24.2574 31.9856 23.8387 32.1139L23.2529 30.2016ZM22.4529 31.7229C22.6509 32.3453 23.3187 32.7136 23.9641 32.5142L23.3735 30.6033C23.7989 30.4719 24.2307 30.7142 24.3588 31.1165L22.4529 31.7229Z",
    fill: "black",
    mask: "url(#path-21-inside-1_6408_1178)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotPurple);
export default __webpack_public_path__ + "static/media/Chatbot_purple.c9c7051392f51e01076e8cef9e790b64.svg";
export { ForwardRef as ReactComponent };